export const routesWithoutNavigation: RegExp[] = [
  /^\/$/,
  /^\/sign-in/,
  /^\/sign-up/,
  /^\/onboarding/,
];

export const routesWithBackButton: [RegExp, string][] = [
  [/^\/profile/, 'profile'],
  [/^\/terms-and-conditions$/, 'termsAndConditions'],
  [/^\/privacy-policy$/, 'privacyPolicy'],
  [/^\/certificate\/[a-zA-Z0-9_-]+$/, 'certificate'],
];
